module.exports = __webpack_public_path__ + "media/olc-poster.3684d8cb.webm";